import { render } from "./AdminModal.vue?vue&type=template&id=8d84f7a4&scoped=true"
import script from "./AdminModal.vue?vue&type=script&lang=js"
export * from "./AdminModal.vue?vue&type=script&lang=js"

import "./AdminModal.vue?vue&type=style&index=0&id=8d84f7a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d84f7a4"]])

export default __exports__